
export default function useImageServer() {

  const getPathImageServer = (originalPath?: string) => {
    return originalPath ? originalPath.replace(/^https?:\/\/[^/]+/, "https://api.eventhub.la") : '';
  }

  return {
    getPathImageServer
  }
}
